module.exports = __webpack_public_path__ + "static/media/19ESCAP18.1c082da8.jpg";